/* eslint complexity: ["error", 6], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

/* eslint-disable indent */
    'use strict';
    Odigeo.defineWidget('dp_upsell_activation_rules_manager', Odigeo.Widget.extend({
        modelClass: Odigeo.Model.extend({
            init: function() {
                this.widget.options = Odigeo.Utils.parseOptions(this.widget.options);
            },

            isRoundTrip: function(searchParams) {
                return searchParams.type === 'roundTrip';
            },

            isOneToMaxNightsAccomplished: function(searchParams) {
                const segments = searchParams.searchSegments;
                let dpUpsellNights = 0;
                const maxNights = this.widget.options.maxNights;
                if (segments.length > 1) {
                    const departureDate = new Date(segments[0].dateStr);
                    const returnDate = new Date(segments[1].dateStr);
                    dpUpsellNights = Odigeo.Utils.getDifferenceInDays(departureDate.getTime(), returnDate.getTime());
                }
                return dpUpsellNights > 0 && dpUpsellNights <= maxNights;
            },

            isCurrentLessThanMaxAppearancesPerSessionAccomplished: function() {
                var currentAppearances = Odigeo.Session.get('dpupsellactivationrules-manager-appearances');
                return this.widget.options.maxAppearancesPerSession === 0 || Odigeo._.isEmpty(currentAppearances) ||
                    currentAppearances < this.widget.options.maxAppearancesPerSession;
            },

            areAirlinesIncludedToShowIP: function(searchParams) {
                const excludedAirlines = this.widget.options.excludedAirlines;
                return Odigeo._.every(excludedAirlines, function(airlineCode) {
                    return Odigeo._.every(searchParams.flightNumbers, function(flightNumber) {
                        return !Odigeo._.includes(flightNumber, ',' + airlineCode);
                    });
                });
            },

            isTelesalesMktPortal: function() {
                return Odigeo.SessionScope.mktPortal.toLowerCase() === this.widget.options.mktPortal;
            },

            checkRules: function(searchParams) {
                return this.isRoundTrip(searchParams) && this.isOneToMaxNightsAccomplished(searchParams) &&
                    this.isCurrentLessThanMaxAppearancesPerSessionAccomplished() && this.areAirlinesIncludedToShowIP(searchParams);
            },

            isIPEnabledInMarket: function() {
                return Odigeo.SessionScope.intermediatePageEnabled === 'true';
            },

            areActivationRulesAccomplished: function(params) {
                const searchParams = params.searchParams;
                return this.isIPEnabledInMarket() && (this.isTelesalesMktPortal() || this.checkRules(searchParams));
            },
        }),

        dic: {
            'areActivationRulesAccomplished': 'areActivationRulesAccomplished',
            'set': 'set',
        },

        execute: function(func, params) {
            if (Odigeo._.includes(this.dic, func) && Odigeo._.isFunction(this.model[this.dic[func]])) {
                const result = this.model[this.dic[func]](params);
                switch (func) {
                    case 'areActivationRulesAccomplished':
                        return result;
                    default:
                        return this;
                }
            }
        },
    }));
